import {AbstractControl, ValidationErrors} from '@angular/forms';
import {Observable, of} from 'rxjs';

export class GenericValidator {

   constructor() {
   }

   /**
    * Valida se o CPF é valido. Deve-se ser informado o cpf sem máscara.
    */
   static validaCPF() {
      return (control: AbstractControl): Observable<ValidationErrors> => {
         const cpf = control.value;
         const valid = this.campoCPF(cpf);
         return valid ? of(null) : of({cnpjCpfInvalid: true, cpfInvalid: true});
      };
   }

   /**
    * Valida CPF. Aceita null e vazio.
    */
   static validaCPFCadastro() {
      return (control: AbstractControl): Observable<ValidationErrors> => {
         const cpf = control.value;
         const valid = this.campoCPF(cpf);
         if (!valid) {
            return of({cnpjCpfInvalid: true});
         } else {
            return of(null);
         }
      };
   }

   /**
    * Valida CNPJ. Aceita null e vazio.
    */
   static validaCNPJ() {
      return (control: AbstractControl): Observable<ValidationErrors> => {
         const cnpj = control.value;
         const valid = this.campoCNPJ(cnpj);
         return valid ? of(null) : of({cnpjCpfInvalid: true});
      };
   }

   /**
    * Valida se o CPF ou CNPJ é valido.
    */
   static validaCPFCNPJ() {
      return (control: AbstractControl): Observable<ValidationErrors> => {
         const cpf = control.value;
         const valid = this.campoCPF(cpf) || this.campoCNPJ(cpf);
         if (!valid) {
            return of({cnpjCpfInvalid: true});
         } else {
            return of(null);
         }
      };
   }


   public static campoCPF(cpf: string): boolean {
      if (cpf == null || cpf.trim().length === 0) {
         return false;
      }

      cpf = cpf.replace(/[^\d]+/g, '');

      if (cpf.length !== 11) {
         return false;
      }
      if (
         cpf === '00000000000' ||
         cpf === '11111111111' ||
         cpf === '22222222222' ||
         cpf === '33333333333' ||
         cpf === '44444444444' ||
         cpf === '55555555555' ||
         cpf === '66666666666' ||
         cpf === '77777777777' ||
         cpf === '88888888888' ||
         cpf === '99999999999'
      ) {
         return false;
      }

      let numero: number = 0;
      let caracter: string = '';
      let numeros: string = '0123456789';
      let j: number = 10;
      let somatorio: number = 0;
      let resto: number = 0;
      let digito1: number = 0;
      let digito2: number = 0;
      let cpfAux: string = '';
      cpfAux = cpf.substring(0, 9);
      for (let i: number = 0; i < 9; i++) {
         caracter = cpfAux.charAt(i);
         if (numeros.search(caracter) == -1) {
            return false;
         }
         numero = Number(caracter);
         somatorio = somatorio + numero * j;
         j--;
      }
      resto = somatorio % 11;
      digito1 = 11 - resto;
      if (digito1 > 9) {
         digito1 = 0;
      }
      j = 11;
      somatorio = 0;
      cpfAux = cpfAux + digito1;
      for (let i: number = 0; i < 10; i++) {
         caracter = cpfAux.charAt(i);
         numero = Number(caracter);
         somatorio = somatorio + numero * j;
         j--;
      }
      resto = somatorio % 11;
      digito2 = 11 - resto;
      if (digito2 > 9) {
         digito2 = 0;
      }
      cpfAux = cpfAux + digito2;
      if (cpf != cpfAux) {
         return false;
      } else {
         return true;
      }
   }

   private static campoCNPJ(cnpj: string): boolean {
      cnpj = cnpj.replace(/\D/g, '');

      if (cnpj.length !== 14) {
         return false;
      }

      if (
         cnpj === '00000000000000' ||
         cnpj === '11111111111111' ||
         cnpj === '22222222222222' ||
         cnpj === '33333333333333' ||
         cnpj === '44444444444444' ||
         cnpj === '55555555555555' ||
         cnpj === '66666666666666' ||
         cnpj === '77777777777777' ||
         cnpj === '88888888888888' ||
         cnpj === '99999999999999') {
         return false;
      }

      const checkDigits = cnpj.slice(-2);
      const digits = cnpj.slice(0, -2);

      const calcDigit = (digits: string, positions: number): number => {
         let sum = 0;
         let index = positions - 7;

         for (let i = positions; i >= 1; i--) {
            sum += parseInt(digits.charAt(positions - i), 10) * index--;
            if (index < 2) {
               index = 9;
            }
         }

         const mod = sum % 11;
         return mod < 2 ? 0 : 11 - mod;
      };

      const digit1 = calcDigit(digits, 12);
      const digit2 = calcDigit(digits + digit1.toString(), 13);

      return checkDigits === `${digit1}${digit2}`;
   }
}
